import { Loader } from '@mantine/core'

export function RouteLoader() {
  return (
    <div className='w-full h-full flex justify-center items-center'>
      <Loader />
    </div>
  )
}
